import { FeatureFlagsClient } from './feature-flags.client'

export * from './feature-flags.types'
export const featureFlagsClient = new FeatureFlagsClient()
